import React from "react";
import { ContentTypeView } from "nystem-components";
import app from "nystem";

const ViewInViewMirror = ({ model, view, path }) => {
  const { fields, contentType, className, viewId } = model;

  const insertVal = (val) => {
    if (!val) return val;
    return val.replace(/\{([a-z_.0-9]+)\}/gim, (str, p1) => {
      if (p1 === "_language") return app().settings.lang;
      if (p1 === "id") return view.id;

      if (p1.indexOf("params.") === 0)
        return view.params[p1.replace("params.", "")];

      if (p1.indexOf("baseView.") !== 0)
        return view.getValue(p1.replace("..", path));

      p1 = p1.replace("baseView.", "");
      return view.baseView.getValue(p1.replace("..", path));
    });
  };

  const onChange = ({ path, value }) => {
    if (path) {
      if (fields.includes(path)) view.setValue({ path, value: value[path] });
    } else
      fields.forEach(
        (field) => field && view.setValue({ path: field, value: value[field] })
      );
  };

  return (
    <ContentTypeView
      className={className}
      contentType={contentType}
      format={model.view}
      id={insertVal(viewId)}
      baseView={view}
      onChange={onChange}
      params={view.params}
    />
  );
};
export default ViewInViewMirror;
